<template>
  <div>
    <VMSMapDetail />
    <br>
    <VMSVideo v-if="owner !== 'psd'" />
    <VMSVideoPSD v-if="owner === 'psd'" />
    <br>
    <VMSTable v-if="check" />
    <br>
    <VMSGraph v-if="check" />
  </div>
</template>

<script>
import axios from '@axios'
import VMSMapDetail from '@/views/vms/detail/VMSMapDetail.vue'
import VMSVideo from '@/views/vms/detail/VMSVideo.vue'
import VMSVideoPSD from '@/views/vms/detail/VMSVideoPSD.vue'
import VMSTable from '@/views/vms/detail/VMSTable.vue'
import VMSGraph from '@/views/vms/detail/VMSGraph.vue'

export default {
  components: {
    VMSMapDetail,
    VMSVideo,
    VMSTable,
    VMSGraph,
    VMSVideoPSD,
  },
  data() {
    return {
      check: false,
      owner: '',
    }
  },
  mounted() {
    this.checkWeather()
  },
  methods: {
    checkWeather() {
      axios
        .post('/checkWeatherCNZ', { wid: this.$route.query.wid })
        .then(response => {
          this.owner = response.data[0].owner
          if (response.data[0].traffic_sign_weather_cnz) {
            this.check = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
